<template lang="html">
  <div class="container column full-height">

    <div class="select-question select-question__height container">
      <div class="select-question__right flex-grow-1">

        <div class="select_question select_question-red container align-items-stretch">
          <div class="img container align-center">
            <img src="@/assets/img/icon-books.svg" width="30" alt="Minds" class="">
          </div>
          <div class="flex-grow-1 bordered-box bordered-box-orange">
            <p>{{ question.question }}</p>
          </div>
        </div>

        <ul class="list-none relative container wrap">
          <li
            v-for="(q, ind) in exercise.questions"
            class="animation-bottom flex-basis-500 flex-grow-1 container align-items-start complete_dialog-container"
            :style="{animationDelay: (ind / 20) + 's'}"
            :key="`question-${ind}`"
          >

            <div
              class="container align-items-start flex-grow-1 complete_dialog"
              :class="{'word-correct' : checkCorrect(q), 'word-wrong' : checkWrong(q), 'disable' : ((ind != index) && !q.answered)}"
            >
              <div class="complete_img">
                <image-loader :src="q.img"/>
              </div>

              <div class="container column flex-grow-1">
                <div class="select-audio-question__item container align-items-center" >
                  <span class="ball">
                    {{ind+1}}
                  </span>
                  <p class="word-center no-margin-bottom container row align-items-center">
                    {{ spliceIntoArray(q).first }}
                    <span class="word_esp" style="display: block;">
                      {{ q.answered?getSelected(q.answers):``}}
                    </span>
                    {{ spliceIntoArray(q).last }}
                  </p>
                </div>

                <audio-player ref='audio' :src="q.audio" class="margin-top-10 animation-bottom animation-delay-05" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="align-self-streach padding-10">
      <div class="select-question__words margin-top-10 complete-dialogs-game">
        <div class="select-question__right flex-grow-1 flex-basis-1200">
          <ul class="list-none relative container nowrap align-items-center justify-content-around relative">
            <li
              v-for="(aswr, ind) in question.answers"
              class="animation-bottom"
              :style="{animationDelay: (ind / 20) + 's'}"
              :key="`answer-${ind}`"
              @click="selectQuestion(aswr)"
            >
              <!-- para nao mostra a resposta correta : word-correct' : word === data.correctWord && finish && correct -->
              <div
                class="select-word__item flex align-items-center"
                :class="{'word-correct' : aswr.correct && question.answered, 'word-wrong' : aswr.selected && !aswr.correct && question.answered }"
              >
                {{aswr.text}}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">

        <transition name="fade">
          <gameFeedback :correct="question.hit" v-show="showFeedback"/>
        </transition>

        <div class="animation-bottom animation-delay-15 bottom-alert" v-if="question.hit && question.answered">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta
          </span>
        </div>
        <div class="animation-bottom animation-delay-15 bottom-alert" v-if="!question.hit && question.answered">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta
          </span>
        </div>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="exercise.questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
    </modal>
  </div>
</template>

<script>
import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";
import { mapGetters } from "vuex";

export default {
  components: {
    gameFeedback,
    modal,
    modalSubTopic
  },
  data() {
    return {
      selected: "",
      finish: false,
      showFeedback: false,
      question: {
        answers: []
      },
      ended: false,
      showInfo: false,
      index: 0
    };
  },
  props: {
    topic: {
      type: Object,
      default: () => new Object()
    },
    subTopic: {
      type: Object,
      default: () => new Object()
    }
  },
  computed: {
    ...mapGetters({
      testMode: 'isTestMode',
      isReview: 'isReview',
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    }),
    exercise () {
      return this.subTopic.exercise
    }
  },
  methods: {
    async selectQuestion (answer) {
      this.$refs[`audio`][this.index].pause()

      let correct = false
      if (!this.question.answered) {
        this.$refs[`audio`][this.index].pause()
        if (answer.correct) correct = true
        else correct = false
        answer.selected = true
        this.question.hit = correct
        this.question.answered = true
        this.selected = answer.text
        this.feedback()
        await this.save(this.question)
      }
    },
    play (index) {
      if (index == this.index) {
        this.$refs['audio'].forEach(a => a.pause())
        this.$refs[`audio`][index].play()
      }
    },
    async feedback () {
      this.showFeedback = true
      if (this.showFeedback) {
        await this.$delay(1500)
        this.showFeedback = false
        gameBus.$emit('setEnabled', true)
      }
    },
    async setCurrent () {
      let qst          = {},
          currentIndex = 0

      const questions = this.exercise.questions
      for (const index in questions) {
        currentIndex = index
        if (!questions[index].answered) {
          this.selected = ``
          qst = questions[index]
          break;
        } else if (parseInt(index) === (questions.length - 1)) {
          qst = questions[index]
          this.ended = true
        }
      }
      this.index = currentIndex
      if (Object.keys(this.question).length == 0 || qst._id !== this.question._id) {
        if (!qst.answered) qst.answers = this.$shuffle(qst.answers)
        this.$set(this, 'question', qst)
        if (this.ended) {
          const wordIndex = questions[this.index].answers.findIndex(x => x.selected)
          this.selected = this.question.answers[wordIndex].word
        }
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    checkCorrect (question) {
      const index = question.answers.findIndex(x => (x.selected && x.correct))
      if (question.answered && (index >= 0)) return true
      else return false
    },
    checkWrong (question) {
      const index = question.answers.findIndex(x => (x.selected && !x.correct))
      if (question.answered && (index >= 0)) return true
      else return false
    },
    getSelected (answers) {
      const index = answers.findIndex(x => x.selected)
      return answers[index].text
    },
    spliceIntoArray (question) {
      const titleArray = question.text.split(' '),
            correctIndex = question.answers.findIndex(x => x.correct)

      let correctWord = ''
      if (correctIndex > -1) correctWord = question.answers[correctIndex].text

      const wordIndex = titleArray.findIndex(x => x.toLowerCase() === correctWord.toLowerCase())

      let firstPart = titleArray.slice(0, wordIndex),
          lastPart  = titleArray.slice(wordIndex + 1, titleArray.length)

      firstPart = firstPart.join(` `)
      lastPart = lastPart.join(` `)
      return {
        first: firstPart,
        last: `${lastPart}.`
      }
    },
    async save (question) {
      let scoreQuestions = 0
      let answered = 0

      for (const qst of this.exercise.questions) {
        for (const aswr of qst.answers) {
          if (aswr.selected && aswr.correct)
            scoreQuestions++
        }

        if (qst.answered)
          answered++
      }

      const score = (scoreQuestions * 100)/this.exercise.questions.length

      let payload = {
        points: score,
        finished: false,
        question: { ...question }
      }

      if (answered == this.exercise.questions.length) {
        payload.finished = true
        this.ended = true
        await this.$delay(1500)
        this.showInfo = true
      }

      gameBus.$emit('updateProgress', score)

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch('subTopic/answerQuestion', payload)
    },
    closeModal () {
      this.showInfo = false
    },
    emitClose () {
      this.$refs['modal'].close()
    },
    async viewQuestion (index) {
      const question = this.exercise.questions[index]
      if (question && question.answered) {
        this.index = index
        this.$set(this, 'question', question)
        const wordIndex = question.answers.findIndex(x => x.selected)

        if (wordIndex > -1)
          this.selected = question.answers[wordIndex].word
      }
    }
  },
  watch: {
    ended(val) {
      gameBus.$emit("setEnded", val);
    },
    index(val) {
      gameBus.$emit("updateIndex", val);
    }
  },
  async beforeMount() {
    this.setCurrent()
    gameBus.$on("viewQuestion", this.viewQuestion);

    gameBus.$emit("updateProgress", this.subTopic.points);
    modalBus.$on("close", this.closeModal);
    gameBus.$on("setCurrent", this.setCurrent);
  },
  beforeDestroy() {
    gameBus.$off("viewQuestion", this.viewQuestion);

    modalBus.$off("close", this.closeModal);
    gameBus.$off("setCurrent", this.setCurrent);
  }
};
</script>

<style lang="scss">
@import "./src/assets/css/components/selectQuestion";
@import "./src/assets/css/components/watchSelectWord";
@import "./src/assets/css/components/answerSelectQuestion";

.no-margin {
  margin: 0 !important;
}

.btn-smallest {
  font-size: 14px;
  padding: 10px;
}

.width-auto {
  width: 100% !important;
}

.complete-dialogs-game {
  background: #ffedb1;

  // .select-word__item {
  //   border: 1px solid #e26200;
  //   background: #ff9900;
  // }
}
.complete_dialog-container {
  padding: 10px;
}

.complete_dialog {
  background: #ff9900;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 10px;

  &.disable {
    background: #ddd;
    cursor: not-allowed;
    pointer-events: none;
    user-select: none;
  }

  &.word-correct {
    background: $color-green;
  }

  &.word-wrong {
    background: $color-red;
  }

  .select-audio-question__item {
    border-radius: 50px;
    margin-bottom: 0;
    padding: 8px;
    box-sizing: border-box;
  }
  .complete_img {
    width: 20%;
    height: 104px;
    margin-right: 20px;
    border-radius: 10px;
    img {
      border-radius: 10px;
      object-fit: cover;
      height: 104px;
      width: 100%;
    }
  }

  .ball {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #6f6f6f;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
  }
}

@media (max-width: 576px) {
  .complete_dialog {
    .complete_img {
      margin-right: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/completeDialogGame.vue